<template>
  <MadeProductUpsert
    v-if="isModalReady"
    ref="madeProductUpsertRef"
    :line-item="currentLineItem"
    :is-cart="false"
    add-mode
    add-another-product
    is-reorder
    @close="handleClose"
    @update:total-price="handleTotalPriceUpdated"
  />
</template>

<script setup>
import { nextTick, ref, onMounted, onUnmounted } from "vue";
import { EventBus, Events } from "jiffy-store";
import MadeProductUpsert from "components/jiffy/vue-cart/LineItem/MadeProductUpsert/MadeProductUpsert.vue";
import { useStore } from "vuex";

const madeProductUpsertRef = ref(null);
const currentLineItem = ref({});
const isModalReady = ref(false);

const store = useStore();

const handleOpen = async (event, data) => {
  const { lineItem } = data || event.target || {};
  currentLineItem.value = { ...lineItem };
  isModalReady.value = true;

  await nextTick();
  madeProductUpsertRef.value?.open();
};

const handleClose = () => {
  isModalReady.value = false;
  currentLineItem.value = {};
};

const enableBuyItAgain = () => {
  const $buyAgainButtons = document.querySelectorAll(".js-made-reorder-button");
  $buyAgainButtons.forEach($button => {
    // eslint-disable-next-line no-param-reassign
    $button.disabled = false;
  });
};

const handleCartQuantityUpdated = (_, event) => {
  const activeCartAmount =
    event.carts.find(cart => cart.number === event.activeCart.number)?.products_subtotal || 0;

  store.commit("setProductsSubtotal", Number(activeCartAmount));

  enableBuyItAgain();
};

const handleTotalPriceUpdated = totalPrice => {
  store.commit("setCurrentTotalPrice", Number(totalPrice || 0));
};

onMounted(() => {
  EventBus.on(Events.OPEN_MADE_PRODUCT_UPSERT_MODAL, handleOpen);
  EventBus.on(Events.SAVED_CARTS_LOADED, handleCartQuantityUpdated);
});

onUnmounted(() => {
  EventBus.removeEventListener(Events.OPEN_MADE_PRODUCT_UPSERT_MODAL, handleOpen);
  EventBus.removeEventListener(Events.SAVED_CARTS_LOADED, handleCartQuantityUpdated);
});
</script>
